import { defineMessages } from 'react-intl';

export default defineMessages({
    categoryFilter: {
        defaultMessage: 'Category',
        description: 'Title of the category picker',
        id: 'sd.all.articles.result.category.filter.name',
    },
});
